import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const Input = ({
  type,
  name,
  label,
  value,
  onChange,
  onBlur,
  disabled,
  placeholder,
  fullWidth,
  error,
  helperText,
  ...rest
}) => (
  <TextField
    type={type}
    name={name}
    label={label}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    variant="outlined"
    disabled={disabled}
    placeholder={placeholder}
    fullWidth={fullWidth}
    error={error}
    helperText={helperText}
    {...rest}
  />
);

Input.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

Input.defaultProps = {
  type: 'text',
  label: null,
  onBlur: () => {},
  disabled: false,
  placeholder: null,
  fullWidth: true,
  error: false,
  helperText: null,
};

export default memo(Input);
